import axios from 'axios'
import store from '@/store'

const urlPath = '/dps/availability'

export default {
  async list(params, callback, errorCallback) {
    let apiUrl = store.state.apiSelected.apiHost
    try {
      let resp = await axios.get(`${apiUrl}${urlPath}/list`, {
        params: params
      })
      callback(resp.data)
    } catch (error) {
      console.log(error)
      errorCallback()
    }
  },
  async changeBulk(payload, callback, errorCallback) {
    let apiUrl = store.state.apiSelected.apiHost
    try {
      let resp = await axios.post(`${apiUrl}${urlPath}/changeBulk`, payload)
      callback(resp.data)
    } catch (error) {
      console.log(error)
      errorCallback()
    }
  },
  async change(payload, callback, errorCallback) {
    let apiUrl = store.state.apiSelected.apiHost
    try {
      let resp = await axios.post(`${apiUrl}${urlPath}/change`, payload)
      callback(resp.data)
    } catch (error) {
      console.log(error)
      errorCallback()
    }
  },
  async isParkingUpdatingAvailabilities(params, callback, errorCallback) {
    let apiUrl = store.state.apiSelected.apiHost
    try {
      let resp = await axios.get(`${apiUrl}${urlPath}/isParkingUpdatingAvailabilities`, {
        params: params
      })
      callback(resp.data)
    } catch (error) {
      console.log(error)
      errorCallback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/availabilityService.js